interface IBlockOptions {
  animate?: boolean;
  boxed?: boolean;
  cenrerY?: boolean;
  iconOnly?: boolean;
  message?: string;
  overlayColor?: string;
  target?: IjQueryElmOrHtmlElm;
  textOnly?: boolean;
  zIndex?: number;
}
export type IDoBlockUI = (ops: IBlockOptions) => void;

export function doBlockUI(ops: IBlockOptions) {
  const blockOptions = $.extend(true, {}, ops);
  let html = '';

  if (blockOptions.animate) {
    html = `<div class="loading-message ${
      blockOptions.boxed ? 'loading-message-boxed' : ''
    }"><div class="block-spinner-bar"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>`;
  } else if (blockOptions.iconOnly) {
    html = `<div class="loading-message ${
      blockOptions.boxed ? 'loading-message-boxed' : ''
    }"><span class="glyphicon glyphicon-refresh glyphicon-spin" aria-hidden="true"></span></div>`;
  } else if (blockOptions.textOnly) {
    html = `<div class="loading-message ${
      blockOptions.boxed ? 'loading-message-boxed' : ''
    }"><span>&nbsp;&nbsp; ${
      blockOptions.message ? blockOptions.message : 'LOADING...'
    }</span></div>`;
  } else {
    html = `<div class="loading-message ${
      blockOptions.boxed ? 'loading-message-boxed' : ''
    }"><span class="glyphicon glyphicon-refresh glyphicon-spin" aria-hidden="true"></span><span>&nbsp;&nbsp; ${
      blockOptions.message ? blockOptions.message : 'LOADING...'
    }</span></div>`;
  }

  if (blockOptions.target) {
    // element blocking
    const el = $(blockOptions.target);
    const elHeight = el.height() || 0;
    const windowHeight = $(window).height() || 0;
    if (elHeight <= windowHeight) {
      blockOptions.cenrerY = true;
    }
    (el as any).block({
      baseZ: blockOptions.zIndex ? blockOptions.zIndex : 1000,
      centerY: blockOptions.cenrerY !== undefined ? blockOptions.cenrerY : false,
      css: {
        backgroundColor: 'none',
        border: '0',
        padding: '0',
        top: '10%',
      },
      message: html,
      overlayCSS: {
        backgroundColor: blockOptions.overlayColor ? blockOptions.overlayColor : '#555',
        cursor: 'wait',
        opacity: blockOptions.boxed ? 0.2 : 0.1,
      },
    });
  } else {
    // page blocking
    ($ as any).blockUI({
      baseZ: blockOptions.zIndex ? blockOptions.zIndex : 1000,
      css: {
        backgroundColor: 'none',
        border: '0',
        padding: '0',
      },
      message: html,
      overlayCSS: {
        backgroundColor: blockOptions.overlayColor ? blockOptions.overlayColor : '#555',
        cursor: 'wait',
        opacity: blockOptions.boxed ? 0.2 : 0.1,
      },
    });
  }
}
